import { z } from 'zod';

export const BucketSummarySchema = z.object({
  name: z.string(),
  summary: z.string(),
  tip: z.string().nullable(), // tip can be a string or null
});

export type BucketSummary = z.infer<typeof BucketSummarySchema>;

export const V1BucketFeedbackResponseSchema = z.object({
  uuid: z.string(),
  summaries: z.array(BucketSummarySchema),
});

export type V1BucketFeedbackResponse = z.infer<typeof V1BucketFeedbackResponseSchema>;
